<template>
  <div class="top-header" v-if="!hasHeader">
    <header id="header" class="header-nav">
      <div :class="defaultIndex == 0 ? 'header-type-0' : 'container header-type-1'">
        <div class="header-left">
          <div class="logo" @click="toHome()">
            <img src="../assets/img/nav/n-4-1.png" />
          </div>
        </div>
        <div class="header-right">
          <div class="header-language">
            <el-dropdown @command="changeLanguage">
              <div class="language-button">
                <div class="language-icon-2">
                  <img src="../assets/img/nav/n-6.png" />
                </div>
                <div>{{ currentLanguageLabel }}</div>
                <div class="language-icon-1">
                  <img src="../assets/img/nav/n-5.png" />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in languageOptions"
                  :key="item.value"
                  class="language-dropdown-item"
                  :command="String(index)">
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="header-login">
            <div class="login-button" v-if="loginState || $store.state.globalData.loginState">
              <el-dropdown @command="toUrl">
                <div
                  style="cursor: pointer; display: flex; align-items: center"
                  :class="hasAvatar ? 'avatar-active' : ''">
                  <img
                    v-show="!hasAvatar && avatar_update_time == 0"
                    class="dropdown-avatar-img"
                    src="../assets/img/login/avatar.png" />
                  <img
                    v-show="hasAvatar && avatar_update_time == 0"
                    class="dropdown-avatar-img"
                    src="../assets/img/login/avatar2.png" />
                  <img v-show="avatar_update_time > 0 && uid" class="dropdown-avatar-img" :src="avatarImageUrl" />
                  {{ userName }}
                  <i v-show="!hasAvatar" class="bi bi-chevron-down dropdown-arrow-icon"></i>
                  <i v-show="hasAvatar" class="bi bi-chevron-up dropdown-arrow-icon"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="user-dropdown-item user-dropdown-item--border" command="1">
                    {{ $t('nav.nav3') }}
                  </el-dropdown-item>
                  <el-dropdown-item class="user-dropdown-item user-dropdown-item--border" command="0">
                    {{ $t('nav.nav2') }}
                  </el-dropdown-item>
                  <el-dropdown-item class="user-dropdown-item" command="2">{{ $t('nav.nav4') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="login-out-button" v-else @click="login()">
              {{ $t('nav.nav5') }}
            </div>
          </div>
        </div>
      </div>
    </header>
    <login ref="login"></login>
  </div>
</template>
<script>
import { getUserInfo } from '../../common/api';
import filters from '../../common/filters';
import login from '@/components/login.vue';

const LOCALE_LIST = ['zh', 'en', 'tw', 'ja', 'ko', 'ru', 'th', 'fr', 'es', 'de', 'it'];

export default {
  components: {
    login
  },
  props: {},
  data() {
    return {
      hasHeader: false,
      defaultIndex: 1,
      language: 'zh',
      loginState: false,
      uid: '',
      userName: '',
      avatar_update_time: -1,
      hasAvatar: false
    };
  },
  computed: {
    languageOptions() {
      return LOCALE_LIST.map((item) => ({
        value: item,
        label: this.$t(`nav.nav_lang_${item}`)
      }));
    },
    currentLanguageLabel() {
      const currentLanguage = this.language || 'zh';
      const currentOption = this.languageOptions.find((item) => item.value === currentLanguage);
      return currentOption ? currentOption.label : this.languageOptions[0].label;
    },
    avatarImageUrl() {
      if (!(this.avatar_update_time > 0 && this.uid)) {
        return '';
      }
      return `${this.$baseImg}/bb/${this.uid}/avatar.png?x-oss-process=image/resize,m_fixed,h_100,w_100&t=${this.avatar_update_time}`;
    }
  },
  watch: {
    $route(to) {
      this.syncHeaderState(to);
      this.loginState = localStorage.getItem('loginState') ? true : false;
      if (this.loginState) {
        this.getUserInfoData();
      }
    }
  },
  mounted() {
    const lang = localStorage.getItem('lang') || filters.getLocale();
    this.language = lang;
    this.syncHeaderState(this.$route);
    this.loginState = localStorage.getItem('loginState') ? true : false;
    this.getUserInfoData();
  },
  methods: {
    syncHeaderState(route) {
      this.hasHeader = route.path === '/mapFull';
      this.defaultIndex = route.path === '/index' ? 1 : 0;
    },
    getUserInfoData() {
      if (this.loginState) {
        const params = {};
        getUserInfo(params).then((res) => {
          if (res.code == 0) {
            this.userName = res.data.email;
            this.uid = res.data.uid;
            this.avatar_update_time = res.data.avatar_update_time;
          } else {
            localStorage.setItem('loginState', '');
          }
        });
      }
    },
    login() {
      this.$nextTick(() => {
        this.$refs.login.dialogFormVisible = true;
        this.$refs.login.activeTab = 0;
        this.$refs.login.initData();
      });
    },
    changeLanguage(index) {
      const lang = LOCALE_LIST[index] || 'zh';
      this.language = lang;
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
    },
    toUrl(index) {
      if (index == 0) {
        this.$router.push({
          path: '/accountSecurity',
          query: {}
        });
      } else if (index == 1) {
        this.$router.push({
          path: '/recorderCloud',
          query: {}
        });
      } else {
        this.$store.commit('updateGlobalData', {
          loginState: false
        });
        localStorage.setItem('loginState', '');
        this.loginState = false;
        this.hasAvatar = false;
        this.$router.push({
          path: '/',
          query: {}
        });
      }
    },
    toHome() {
      window.open('https://vormor.cn/');
    }
  }
};
</script>

<style lang="scss" scoped>
.top-header {
  position: relative;
  .header-nav {
    height: 74px;
    display: flex;
    align-items: center;

    .header-type-0 {
      width: 100%;
      padding: 0 26px;
      display: flex;
      justify-content: space-between !important;
    }
    .header-type-1 {
      display: flex;
      justify-content: space-between !important;
    }
    .header-left {
      display: flex;
      align-items: center;
      .logo {
        width: 50px;
        height: 36px;
        cursor: pointer;
        img {
          width: 50px;
          height: 36px;
        }
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .header-language {
        .language-button {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;

          display: flex;
          align-items: center;
          .language-icon-2 {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            img {
              width: 16px;
              height: 16px;
            }
          }
          .language-icon-1 {
            width: 16px;
            height: 16px;
            margin-left: 8px;
            img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
      .header-login {
        .login-button {
          margin-left: 48px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
        .login-out-button {
          margin-left: 0.48rem;
          min-width: 82px;
          padding: 0 10px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
      }
    }
  }
}

::v-deep .language-dropdown-item {
  text-align: left;
}

::v-deep .user-dropdown-item {
  text-align: center;
}

::v-deep .user-dropdown-item--border {
  border-bottom: 1px solid #e5e5e5;
}

::v-deep .el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(230, 244, 244, 1);
  color: rgba(16, 177, 167, 1);
}

.dropdown-avatar-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 8px;
}

.dropdown-arrow-icon {
  margin-left: 4px;
}
</style>
